<script lang="ts">
	import DefaultOgImage from '$lib/components/DefaultOgImage.svelte';
</script>

<DefaultOgImage />

<div class="max-w-screen-lg px-4 xl:px-0 mx-auto">
	<slot />
</div>
